import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    paginationHolder: {
      marginTop: Spacings.s48,
      marginBottom: Spacings.s64,
      [mediaQuery(BreakPoints.Small)]: {
        marginTop: Spacings.s32,
        marginBottom: Spacings.s40,
      },
    },
    masonryGridWrapper: {
      marginTop: Spacings.s12,

      [mediaQuery(BreakPoints.Small)]: {
        marginTop: 0,
      },
    },
  },
  {
    name: 'category-grid',
  },
);
export default useStyles;
